// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionList_container__1Krqz","avatar":"SuggestionList_avatar__VFDON","memberContainer":"SuggestionList_memberContainer__JXXyp","name":"SuggestionList_name__x7onF"};